console.log('starting ..')
import './fonts/fonts.css';
import './lib/components/vxc_topbar.ts'
import './lib/components/vxc_navbar.ts'
import './lib/components/vxc_widget.ts'
import './lib/components/vxc_valuebox.ts'
import './lib/components/vxc_valuelist.ts'
import './lib/components/vxc_chart.ts'
import './lib/components/vxc_select.ts'
import './lib/components/vxc_form.ts'
import './lib/components/vxc_modal.ts'
import './lib/components/vxc_datatable.ts'
import './lib/widgets/vxw_menu.ts';
import './lib/views/vxv_login.ts';
import './lib/views/vxv_main.ts';
import './lib/views/vxv_dashboard.ts';
import './lib/apps/vxa_dashboard.ts';